import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import defaultSettings from '@resources/defaultSettings';
import locales from "@root/hydraExtension/config/locales.json";
import Backend from "i18next-http-backend";
import pagesConfig from "@extension/config/pagesConfig"

const init = async (lang?: string) => {
    const currentLang = lang || defaultSettings.lang;

    await i18n
        .use(Backend)
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            fallbackLng: defaultSettings.lang,
            debug: process.env.REACT_APP_NODE_ENV === "development",
            lng: currentLang,
            load: "languageOnly",
            backend: {
                loadPath: `${pagesConfig.rootUrl ? `/${pagesConfig.rootUrl}` : ""}/locales/{{lng}}/{{ns}}.json`,
                crossDomain: false,
            },
            // detection: {
            //     order: ["localStorage", "navigator"],
            // },
            react: {
                useSuspense: true,
            },
            ns : locales,
            returnObjects: true
        });

    return
}

export default init;
